import axios from "axios";

export const getQuantityGroup = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/device/group/quantity`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    res.data.pop();

    const total = res.data.reduce(
      (
        acc: number,
        obj: { name: string; total: number; disconnectedDevice: number }
      ) => acc + obj.total,
      0
    );
    const disconnectedTotal = res.data.reduce(
      (
        acc: number,
        obj: { name: string; total: number; disconnectedDevice: number }
      ) => acc + obj.disconnectedDevice,
      0
    );

    return {
      total,
      disconnectedTotal,
      list: res.data,
    };
  } catch (e) {
    console.log(e);
    return {
      total: 0,
      disconnectedTotal: 0,
      list: [],
    };
  }
};

export const getLinks = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/info/link`, {
      auth: {
        username: process.env.REACT_APP_API_KEY_USERNAME,
        password: process.env.REACT_APP_API_KEY_PASSWORD,
      },
    });
    const data = res.data.map((data: any, index: number) => ({
      groupName: data.groupName,
      links: data.siteLinks,
    }));

    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
